import { connect } from 'react-redux';

import AgeRatings from './age-rating.component';
import { State } from 'widgets/free-content/root/root.reducers';
import { IAgeRatingPropsContainer } from './age-ratings.types';

const mapStateToProps = (state: State): IAgeRatingPropsContainer => ({
    countryCode: state.IPLocation?.data?.countryCode ?? '',
});

const AgeRatingsContainer = connect<IAgeRatingPropsContainer>(
    mapStateToProps
)(AgeRatings);

export default AgeRatingsContainer;
